import { Outlet, useNavigate } from "react-router-dom";
import SettingsSideBar from "../../components/Settings/SettingsSidebar";
import { useEffect, useState } from "react";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import SidebarNav from "../../components/Settings/SidebarNav";

const ModularApps = () => {
  const navigate = useNavigate();
  const { SelectedOrg } = useStateGetter();
   const ModuleCats = [
    { title: "All", onclick: () => {} },
    { title: "Financial Management", onclick: () => {} },
    { title: "Human Resource Management", onclick: () => {} },
    { title: "Inventory Management", onclick: () => {} },
    { title: "Custom Modules/Plugins", onclick: () => {} },
  ];
  useEffect(() => {
    if (!SelectedOrg?.orgName) {
   //   navigate("/home");
      toast("Select an Org/Business or Create one", {
        toastId: "customId",
      });
    }
  }, []);
  return (
    <div className="h-full w-screen flex mt-4 ">
      <div className="w-[30vw] px-14 h-full">
        <SidebarNav title="Modular Apps" items={ModuleCats} />
      </div>

      <div className=" w-[70vw] flex justify-start items-start ">
        <Outlet />
      </div>
    </div>
  );
};

export { ModularApps };
